/**
 * @desc - img要素とCSS背景画像をRetina対応する
 * @link - http://combitaro.net/article/146
 */

if (window.devicePixelRatio > 1) {
  $(".2x").each(function () {
    if ($(this).get(0).tagName == "IMG") {
      $(this).attr("src", $(this).attr("src").replace(/(\.)(png|jpg|gif)/, "@2x$1$2"));
    } else {
      $(this).css("background-image", $(this).css("background-image").replace(/(\.)(png|jpg|gif)/, "@2x$1$2"));
    }
  });
}